import React from "react";
import '../Footer/Footer.css'
export default function Footer() {
  return (
    <div id="footer"></div>
  );
}
